// import HtmlDom from "../main/HtmlDom";
// import commonTemplate from "../templates/common.html";
// import commonHeaderTemplate from "../templates/commonHeader.html";
// import commonAddBubbleTemplate from "../templates/commonAddBubble.html";
// import commonAddBubbleCatItemTemplate from "../templates/commonAddBubbleCatItem.html";

import AI_helperItemClass from "./ai_helperItemClass";
// import additionalGroupTemplate from "../templates/additionalGroup.html";
// import groupAddBubbleTemplate from "../templates/groupAddBubble.html";
// import groupHeaderTemplate from "../templates/groupHeader.html";
// import addButtonTemplate from "../templates/addButton.html";


let AI_helperCommonClass = function(o, index, CRM) {
	this.type = 'complect';
	this.crm = CRM;
	this.index = index;
	this.folderURL = CRM.folderURL;
	this.id = 0;
	this.hh = 'ИНТЕЛЛЕКТУАЛЬНЫЙ РАСЧЕТ ЗАКАЗА';
	this.hh_add = '';
	this.debug = CRM.debug;
	this.service_debug = CRM.service_debug;
	this.user = CRM.user;
	this.sale_exceptions = CRM.sale_exceptions;
	this.sale_exceptions_cashback = CRM.sale_exceptions_cashback;
	this.discount_pics_ids = CRM.discount_pics_ids;
	this.infoFields={};
	this.exceptions = CRM.exceptions;
	this.profile = CRM.profile;
	this.groups = {};
	this.goods = {};
	this.dom = null;
	this.containers = {
		handle: null,
		header: null,
		items: null,
		total: null,
	};
	this.calculated=false;
	this.full = false;
	this.table_goods = null;
	this.sale = 0;
	this.wholeSum = 0;
	//this.makePost = CRM.makePost;
	this.minimized = false;
	this.controls = {
		selector: null,
		count: null,
		square: null,
		count_but: null,
		square_but: null,
		minimize: null,
		destroy: null,
	};
	this.header = 'КАТАЛОГ КОМПЛЕКТУЮЩИХ';
	this.basket_sum = 0;
	this.salesum = 0;
	this.saletotalsum = 0;
	this.cashbackSum = 0;


	this.categories = {};
	this.ids = [];
	this.selected_items = [];
	this.items = [];


    this.catItems = [];
    this.catsDom = null;

    this.addButton = null;

	this.next_sum = 0;
	this.next_sale = 0;

	this.groupMinimized = false;

    this.inBusket = true;

    this.date = null;

	this.release = function () {
		let groups = [];
		let goods = [];
		for (let k in this.groups) {
			if (Object.prototype.hasOwnProperty.call(this.groups, k)) {
				let group = this.groups[k];
				groups[groups.length] = group.release();
			}
		}
		for (let k in this.goods) {
			if (Object.prototype.hasOwnProperty.call(this.goods, k)) {
				let good = this.goods[k];
				goods[goods.length] = good.release();
			}
		}
		return {
			id: this.id,
			hh: this.hh,
			hh_add: this.hh_add,
			index: this.index,
			respond: this.respond,
			sale_exceptions: this.sale_exceptions,
			sale_exceptions_cashback: this.sale_exceptions_cashback,
			discount_pics_ids: this.discount_pics_ids,
			exceptions: this.exceptions,
			sale: this.sale,
			wholeSum: this.wholeSum,
			groups: groups,
			goods: goods,
			restore: true,
			id_good: this.id_good,
			minimized: this.minimized,
			groupMinimized: this.groupMinimized,
			date: this.date
		}
	};
	this.init = function (o) {
		// let model={};
		// this.dom = new HtmlDom(commonTemplate, model, this);
		// this.containers.header = this.dom.querySelectorAll('[containers="header"]')[0];
		// this.containers.items = this.dom.querySelectorAll('[containers="items"]')[0];
		// this.containers.total = this.dom.querySelectorAll('[containers="total"]')[0];
		// //this.controls.selector = this.dom.querySelectorAll('[controls="selector"]')[0];
		// this.controls.minimize = this.dom.querySelectorAll('[controls="minimize"]')[0];
		// //this.controls.calculated = this.dom.querySelectorAll('[controls="calculated"]')[0];
		// this.controls.header = this.dom.querySelectorAll('[controls="header"]')[0];
		// this.controls.total_header = this.dom.querySelectorAll('[controls="total_header"]')[0];
		// this.controls.group_header = this.dom.querySelectorAll('[controls="group_header"]')[0];
		// this.infoFields.total={};
		// this.infoFields.total.sum = this.dom.querySelectorAll('[model="sum"]')[0];
		// this.infoFields.total.sale = this.dom.querySelectorAll('[model="sale"]')[0];
		// this.infoFields.total.sale_sum = this.dom.querySelectorAll('[model="sale_sum"]')[0];
		// this.infoFields.total.total = this.dom.querySelectorAll('[model="total"]')[0];
		// this.infoFields.total.next_sale = this.dom.querySelectorAll('[model="next_sale"]')[0];
		// this.infoFields.total.next_sum = this.dom.querySelectorAll('[model="next_sum"]')[0];
		// this.containers.items.innerHTML = '';
		// this.table_goods = document.createElement('table');
		// this.table_goods.setAttribute('class', 'ihelper_complect-table');
		// let header= new HtmlDom(commonHeaderTemplate, {}, this);
		// this.controls.info = header.querySelectorAll('[controls="info"]')[0];
		// this.table_goods.appendChild(header);
		// this.containers.items.appendChild(this.table_goods);
		// this.addButton = new HtmlDom(addButtonTemplate, model, this);
		this.createBubble();
		if (typeof o !== "undefined" && o != null) {
			let self = this;
			this.crm.makePost('aiHelper', 'get_common_cat', {}, null, function (respond) {
				// console.log('get_common_cat', respond)

				if (respond.status === 'OK') {
					self.categories = respond.data;
					self.getCategoriesDom();
				}
			});
			if (typeof o.restore !== "undefined")
				this.init_restore(o);
			else
				this.init_new(o);

		}
	};
	this.init_restore = function (o) {
		// console.log('RESTORE COMPL Common', o);
		if (o.id)this.id = o.id;
		if (o.hh)this.hh = o.hh;
		if (o.hh_add)this.hh_add = o.hh_add;
		if (o.index)this.index = o.index;
		if (o.respond)this.respond = o.respond;
		if (o.sale_exceptions)this.sale_exceptions = o.sale_exceptions;
		if (o.sale_exceptions_cashback)this.sale_exceptions_cashback = o.sale_exceptions_cashback;
		if (o.discount_pics_ids) this.discount_pics_ids = o.discount_pics_ids;
		if (o.exceptions) this.exceptions = o.exceptions;
		if (o.sale) this.sale = o.sale;
		if (o.wholeSum) this.wholeSum = o.wholeSum;

		if (o.minimized) this.minimized = o.minimized;
		if (o.groupMinimized) this.groupMinimized = o.groupMinimized;

        if (o.date) this.date = o.date;

		if (o.ids) this.ids = o.ids;
		// this.controls.header.innerHTML = this.hh + ' ' + this.hh_add;
		// this.controls.total_header.innerHTML = this.hh + ' ' + this.hh_add;
		// this.controls.group_header.innerHTML = this.hh + ' ' + this.hh_add;
		// console.log('og', o.goods)
		if (o.goods.length > 0) {
			let self = this;
			for (let key in o.goods) {
				if (Object.prototype.hasOwnProperty.call(o.goods, key)) {
					let val = o.goods[key];
					// console.log('val', val)
					let good = new AI_helperItemClass(val, self, function () {
						self.check_complect();
					});
					// console.log('new', good)
					if (good.enableStock) {
						self.ids.push(good.id);
						self.goods[good.id] = good;
						self.goods[good.id].append(self.table_goods);
					}
				}
			}
		}
		this.check_complect();
	};
	this.init_new = function (o) {
		if (o.id) this.id = o.id;
		if (o.folder) this.hh = o.folder;
		if (o.name) this.hh_add = o.name;
		if (o.id_good) this.id_good = o.id_good;
		this.date = new Date();
		// this.controls.header.innerHTML = this.hh + ' ' + this.hh_add;
		// this.controls.total_header.innerHTML = this.hh + ' ' + this.hh_add;
		// this.controls.group_header.innerHTML = this.hh + ' ' + this.hh_add;
		// this.maximize();
		this.check_complect();
		//this.parts(this.id,false);
	};
	this.renderFields=function() {
		// for(let key in this.infoFields) {
		// 	if (Object.prototype.hasOwnProperty.call(this.infoFields, key)) {
		// 		let block = this.infoFields[key];
		// 		if (block[model]) {
		// 			if (typeof value === 'string') {
		// 				block[model].innerHTML = value;
		// 			} else {
		// 				block[model].innerHTML = window.number_format(value, 2, '.', ' ');
		// 			}
		// 		}
		// 	}
		// }
	};
	this.destroy = function () {
		// delete (this.dom);
		// this.dom = null;
		// delete (this.crm.complects[this.index]);
		// this.check_complect();
		// //console.log(this.crm.complects);
		// this.crm.render();
	};
	this.changeMinimize = function() {
		// if (this.minimized) {
		// 	this.crm.minimize_complects();
		// 	this.maximize();
		// } else {
		// 	this.minimize();
		// }
		// this.crm.updateComplectsInfo();
	};
	this.minimize = function () {
		// if (this.containers.header) this.containers.header.style.display = 'none';
		// if (this.containers.items) this.containers.items.style.display = 'none';
		// if (this.containers.total) this.containers.total.style.display = 'none';
		// if (this.controls.selector) this.controls.selector.style.display = 'none';
		// this.controls.minimize.innerHTML = 'Развернуть';
		// this.minimized = true;
	};
	this.maximize = function () {
		// if (this.calculated) {
		// 	if (this.containers.total) this.containers.total.style.display = 'block';
		// }
		// if (this.containers.items) this.containers.items.style.display = 'block';
		// if (this.containers.header) this.containers.header.style.display = 'block';
		// if (this.controls.selector) this.controls.selector.style.display = 'block';
		// this.controls.minimize.innerHTML = 'Свернуть';
		// this.minimized = false;
	};
	/*
	this.getSumBySale = function (sale, lim) {
		let ret = 0;
		let maxV = 0;
		let maxK = 0;
		if (lim) {
			for (let k in lim) {
				if (lim.hasOwnProperty(k)) {
					let v = lim[k];
					k = parseInt(k);
					if (k === sale) {
						ret = v;
						break;
					} else {
						if (v > maxV) maxV = v;
						if (k > maxK) maxK = k;
					}
				}
			}
		}
		if (ret === 0) {
			if (sale > 0)
				ret = maxV;
			if (sale > maxK && sale < 30)
				sale = 30;
		}
		ret = ret * 1000;
		return {sale: sale, sum: ret};
	};
	this.getSaleBySum = function (sum, lim) {
		let ret = 0;
		let max = 0;
		let prevV = 0;
		if (lim) {
			for (let k in lim) {
				if (lim.hasOwnProperty(k)) {
					let v = lim[k];
					ret = parseInt(k);
					let vv = v * 1000;
					if (prevV < sum && vv >= sum){
						break;
					}
					if (v > max) max = v;
					prevV = v;
				}
			}
		}
		return {sale: ret, sum: sum};
	};
	this.getNextBySale = function (sale, lim) {
		let self = this;
		let ret = {sale: 0, sum: 0};
		let prevV = 0;
		let maxV = 0;
		let maxK = 0;
		if (lim) {
			for (let k in lim) {
				if (lim.hasOwnProperty(k)) {
					let v = lim[k];
					k = parseInt(k);
					if (k > sale) {
						ret = {sale: k, sum: prevV};
						break;
					}
					if (v > maxV) maxV = v;
					if (k > maxK) maxK = k;
					prevV = v * 1000;
				}
			}
		}
		maxV = maxV * 1000;
		if (ret.sum === 0) {
			if (sale > 0) ret.sum = maxV;
			if (sale >= maxK) {
				if (self.full) ret.sale = 35;
				else {
					ret.sale = 30;
					ret.sum = 0;
				}
			}
		}
		if (sale >= 35) ret = {sale: 0, sum: 0};
		return ret;
	};
	this.get_basket_sum = function () {
		let basket_sum = 0;
		for (let k in this.groups) {
			if (this.groups.hasOwnProperty(k)) {
				let v = this.groups[k];
				basket_sum += v.sum;
			}
		}
		for (let k in this.goods) {
			if (this.goods.hasOwnProperty(k)) {
				let v = this.goods[k];
				basket_sum += v.sum;
			}
		}
		this.basket_sum = basket_sum;
		return basket_sum;
	};

*/
	this.getSumBySale = function (sale, lim) {
		let ret = 0;
		let maxV = 0;
		let maxK = 0;
		if (lim) {
			for (let k in lim) {
				if (Object.prototype.hasOwnProperty.call(lim, k)) {
					let v = lim[k];
					k = parseInt(k);
					if (k === sale) {
						ret = v;
						break;
					} else {
						if (v > maxV) maxV = v;
						if (k > maxK) maxK = k;
					}
				}
			}
		}
		if (ret === 0) {
			if (sale > 0)
				ret = maxV;
			if (sale > maxK && sale < 30)
				sale = 30;
		}
		ret = ret * 1000;
		return {sale: sale, sum: ret};
	};
	this.getSaleBySum = function (sum, lim) {
		let ret = 0;
		let max = 0;
		let prevV = 0;
		if (lim) {

			// console.log('-->',lim,sum);
			for (let k in lim) {
				if (Object.prototype.hasOwnProperty.call(lim, k)) {
					let v = lim[k];
					ret = parseInt(k);
					let vv = v * 1000;
					if (prevV < sum && vv >= sum)
						break;
					if (v > max) max = v;
					prevV = v;
				}
			}
		}
		return {sale: ret, sum: sum};
	};
	this.getNextBySale = function (sale, lim) {
		let self = this;
		let ret = {sale: 0, sum: 0};
		let prevV = 0;
		let maxV = 0;
		let maxK = 0;
		if (lim) {
			for (let k in lim) {
				if (Object.prototype.hasOwnProperty.call(lim, k)) {
					let v = lim[k];
					k = parseInt(k);
					if (k > sale) {
						ret = {sale: k, sum: prevV};
						break;
					}
					if (v > maxV) maxV = v;
					if (k > maxK) maxK = k;
					prevV = v * 1000;
				}
			}
		}
		maxV = maxV * 1000;
		if (ret.sum === 0) {
			if (sale > 0) ret.sum = maxV;
			if (sale >= maxK) {
				if (self.full) ret.sale = 35;
				else {
					ret.sale = 30;
					ret.sum = 0;
				}
			}
		}
		if (sale >= 35) ret = {sale: 0, sum: 0};
		return ret;
	};
	this.get_basket_sum = function () {
		let basket_sum = 0;
		for (let k in this.groups) {
			if (Object.prototype.hasOwnProperty.call(this.groups, k)) {
				let v = this.groups[k];
				basket_sum += v.sum;
			}
		}
		for (let k in this.goods) {
			if (Object.prototype.hasOwnProperty.call(this.goods, k)) {
				let v = this.goods[k];
				basket_sum += v.sum;
			}
		}
		this.basket_sum = basket_sum;
		return basket_sum;
	};





	this.event = function() {
		this.check_complect();
		if (this.bubbleItemClasses) {
			for(let key in this.bubbleItemClasses) {
				if (Object.prototype.hasOwnProperty.call(this.bubbleItemClasses, key)) {
					if (this.bubbleItemClasses[key]) {
						this.bubbleItemClasses[key].setSale(this.sale);
					}
				}
			}
		}

	};



	this.check_complect = function () {
		//	console.log('this.user.sum',this.user.sum);
		this.crm.check_complect(this.user.sum);
	};
	this.check_complect_exe = function (fs) {
		// console.log(this.user.cid)
		if (!this.user.cid) return false;
		if (!this.user.sum) this.user.sum = 0;
		if (!this.user.sale) this.user.sale = 0;
		if (!this.user.max_sum) this.user.max_sum = 0;

		this.sale = this.user.sale;

// console.log('COMMON', this);
		if (this.ids.length >0) {
			this.calculated = true;
			// if (this.controls.info) this.controls.info.style.display = 'none';
			// if (this.controls.calculated) this.controls.calculated.style.display = 'block';
			// if (this.containers.total && !this.minimized) this.containers.total.style.display = 'block';
		} else {
			this.calculated = false;
			// if (this.controls.info) this.controls.info.style.display = 'table-row';
			// if (this.controls.calculated) this.controls.calculated.style.display = 'none';
			// if (this.containers.total) this.containers.total.style.display = 'none';

		}




		let self = this;
		let next_sale;
		let next_sum;
		let basket_sum = self.basket_sum;
		self.fullsum = this.user.sum + fs.fullsum;
		let lim = self.user.sale_limits.main;
		//console.log('SALE',self.sale);
		if (self.fullsum >0) {
			self.sale = self.getSaleBySum(self.fullsum, lim).sale;
		}

		//console.log('SALE',self.sale);
		let next = self.getNextBySale(self.sale, lim);
		next_sum = next.sum - self.user.sum - fs.fullsum;
		next_sale = next.sale;

		this.next_sum = next_sum;
		this.next_sale = next_sale;
		let basket_sale_sum = 0;
		let cashbackSum = 0;
		this.wholeSum = basket_sum;
		//console.log('COMMON FULLSUM',  self.fullsum);
		/*
		for (let k in this.groups) {
			if (this.groups.hasOwnProperty(k)) {
				let v = this.groups[k];
				//v.setSale(self.sale, self.wholeSum);
				v.setSale(self.sale, self.fullsum);
				cashbackSum += v.cashbackSum;
				basket_sale_sum += v.sale_sum;
			}
		}

		*/
		for (let k in this.goods) {
			if (Object.prototype.hasOwnProperty.call(this.goods, k)) {
				let v = this.goods[k];			//v.setSale(self.sale, self.wholeSum);
				v.setSale(self.sale, self.fullsum);
				cashbackSum += v.cashbackSum;
				basket_sale_sum += v.sale_sum;
			}
		}



		/*
		for (let k in this.groups) {
			if (this.groups.hasOwnProperty(k)) {
				let v = this.groups[k];
				if (v.restAmount > 0 && v.amount > 0) this.full = false;
			}
		}
		let basket_sum = this.basket_sum;
		this.fullsum = this.user.sum + fs;
		let lim = [];
		//this.user.sale_limits.main;
		if (this.full)
			lim = this.user.sale_limits.full;
		else
			lim = this.user.sale_limits.main;
		this.sale = this.getSaleBySum(this.fullsum, lim).sale;
		let next = this.getNextBySale(this.sale, lim);
		let next_sum = next.sum - this.user.sum - fs;
		let next_sale = next.sale;
		if (this.full) {
			let curr = this.getSumBySale(this.sale, lim);
			if (curr.sum <= this.fullsum && this.sale >= 30) {
				this.sale = 35;
				next_sale = 0;
			} else
				this.sale = curr.sale;
		}
		let basket_sale_sum = 0;
		let cashbackSum = 0;
		this.wholeSum = basket_sum;
		//console.log('COMPLECT FULLSUM',  this.fullsum);
		for (let k in this.groups) {
			if (this.groups.hasOwnProperty(k)) {
				let v = this.groups[k];
				//v.setSale(this.sale, this.wholeSum);
				//console.log('SALE', this.sale);
				v.setSale(this.sale, this.fullsum);
				cashbackSum += v.cashbackSum;
				basket_sale_sum += v.sale_sum;
			}
		}
		for (let k in this.goods) {
			if (this.goods.hasOwnProperty(k)) {
				let v = this.goods[k];
				//v.setSale(this.sale, this.wholeSum);
				v.setSale(this.sale, this.fullsum);
				cashbackSum += v.cashbackSum;
				basket_sale_sum += v.sale_sum;
			}
		}

		*/
		let total_sale_sum = basket_sum - basket_sale_sum;
		cashbackSum = Math.round(cashbackSum * 100) / 100;
		basket_sum = Math.round(basket_sum * 100) / 100;
		basket_sale_sum = Math.round(basket_sale_sum * 100) / 100;
		total_sale_sum = Math.round(total_sale_sum * 100) / 100;
		this.cashbackSum = cashbackSum;
		this.salesum = total_sale_sum;
		this.saletotalsum = basket_sale_sum;
		//if (this.containers.total) this.containers.total.style.display='block';
		this.renderFields('sum',basket_sum);
		this.renderFields('sale',this.sale);
		this.renderFields('sale_sum',total_sale_sum);
		this.renderFields('total',basket_sale_sum);
		if (this.sale === 35) {
			this.renderFields('next_sale','<span style="color:red;">У Вас максимальная скидка!!!</span>');
			this.renderFields('next_sum','');
		} else if (next_sum > 0) {
			this.renderFields('next_sale','Для получения скидки <span style="color:red;">' + next_sale + '%</span> необходимо увеличить заказ на сумму, руб.');
			this.renderFields('next_sum',next_sum);
		} else {
			this.renderFields('next_sale','У Вас максимальная скидка!');
			//this.renderFields('next_sale','Для получения скидки <span style="color:red;">' + next_sale + '%</span> необходимо Заказать полный комплект');
			this.renderFields('next_sum','');
		}
		return true;
	};
	/*
	this.addItem = function (item) {
		this.goods[item.id] = item;
		this.ids.push(item.id);
		item.append(this.table_goods);
		//this.bubbleDestroy();
		//this.check_complect();
	};
	this.deleteItem = function (item) {
		let self = this;
		self.ids = [];
		if (self.goods[item.id]) {
			self.table_goods.removeChild(self.goods[item.id].dom);
			delete (self.goods[item.id]);
		}
		for (let k in self.goods) {
			if (self.goods.hasOwnProperty(k)) {
				if (o.goods[k]) {
					let v = o.goods[k];
					self.ids.push(v.id);
				}
			}
		}
		self.check_complect();
	};

	 */


	this.addItem = function (item) {
		this.goods[item.id] = item;
		this.ids.push(item.id);
		item.append(this.table_goods);
		this.event(null);
		//this.bubbleDestroy();
		//this.check_complect();
	};
	this.deleteItem = function (item) {
		let self = this;
		self.ids = [];
		if (self.goods[item.id]) {
			// self.table_goods.removeChild(self.goods[item.id].dom);
			delete (self.goods[item.id]);
		}
		for (let k in self.goods) {
			if (Object.prototype.hasOwnProperty.call(self.goods, k)) {
				let v = self.goods[k];
				self.ids.push(v.id);
			}
		}
		self.check_complect();
	};







	this.srt = function (o) {
		let arr = [];
		for (let k in o) {
			if (Object.prototype.hasOwnProperty.call(o, k)) {
				arr[arr.length] = o[k];
			}
		}
		arr.sort(function (a, b) {
			return a.name_trunc > b.name_trunc
		});
		return arr;
	};
	this.collect_selected_items = function (items) {
		this.selected_items = [];
		for (let k in items) {
			if (Object.prototype.hasOwnProperty.call(items, k)) {
				// let item = items[k];
				if (items[k]) {
					if (items[k].selected && this.ids.indexOf(items[k].id) === -1) {
						this.selected_items[this.selected_items.length] = items[k];
					}
				}
			}
		}
		// if (this.selected_items.length > 0)
		// 	this.addButton.style.display = 'block';
		// else
		// 	this.addButton.style.display = 'none';
		//console.log(this.selected_items);
	};
	this.catItemClick = function(e,o) {
		let item= o.parentNode;
		let id = item.getAttribute('ihelper_commonCat-id');
        for (let key in this.catItems) {
            if (Object.prototype.hasOwnProperty.call(this.catItems, key)) {
                if (this.catItems[key]) {
                    // console.log('CAT',this.catItems[key]);
                    window.removeClass(this.catItems[key], 'picked');
                }
            }
        }
        window.addClass(item, 'picked');
        if (window.hasClass(item, 'maincat')){
            for (let key in this.catItems) {
                if (Object.prototype.hasOwnProperty.call(this.catItems.key)) {
                    if (this.catItems[key]) {
                        // window.removeClass(this.catItems[key], 'active');
                    }
                }
            }
            window.addClass(item, 'active');
        }
       // console.log('ID',id);
		this.get_common_bubble(id);
	};
	this.get_common_bubble = function (id) {
		let self = this;
		let data = {id: id};
		self.crm.makePost('aiHelper', 'get_common_bubble', data, null, function (respond) {
			if (respond.status === 'OK') {
				self.bubble_data = respond.data.items;
				// self.bubbleLoaded(respond.data.items);
			} else {
				// self.bubble.content.innerHTML = 'ОШИБКА!!!';
				//self.bubbleDestroy();
			}
		});
	};
	this.createBubble = function() {
		// this.bubble = new HtmlDom(commonAddBubbleTemplate, {header:this.header}, this);
		// this.bubble.style.display='none';
		// this.containers.bubbleCats = this.bubble.querySelectorAll('[containers="cats"]')[0];
		// this.containers.bubbleItems = this.bubble.querySelectorAll('[containers="items"]')[0];
		// this.containers.bubbleHeader = this.bubble.querySelectorAll('[containers="header"]')[0];
		//
		// let header = new HtmlDom(groupHeaderTemplate, {}, this);
		// this.containers.bubbleHeader.appendChild(header);
		//
		// this.crm.mainContainer.appendChild(this.bubble);
	};
	this.getCategoriesDom = function () {
		// let self = this;
		// let catDoms = [];
		// let sortFunction = function (a, b) {
		// 	let aname = a.name.toLowerCase();
		// 	let bname = b.name.toLowerCase();
		// 	if (aname < bname) return -1;
		// 	if (aname > bname) return 1;
		// };
		//
		// let dom0 = document.createElement('sss');
		//
		// let items1 = Object.keys(self.categories).map(function (key) {return self.categories[key];});
		// items1.sort(sortFunction);
		// for (let k1 in items1) {
		// 	let dom1 = new HtmlDom(commonAddBubbleCatItemTemplate, {id:items1[k1].id, name:items1[k1].name, class:'maincat'}, this);
		// 	if (dom1) catDoms.push(dom1);
		// 	dom0.appendChild(dom1);
		// 	let items2 = Object.keys(items1[k1].items).map(function (key) {return items1[k1].items[key];});
		// 	items2.sort(sortFunction);
		// 	for (let k2 in items2) {
		// 		let dom2 = new HtmlDom(commonAddBubbleCatItemTemplate, {id:items2[k2].id, name:items2[k2].name, class:'subcat'}, this);
		// 		if (dom2) catDoms.push(dom2);
		// 		dom1.appendChild(dom2);
		// 		let items3 = Object.keys(items2[k2].items).map(function (key) {return items2[k2].items[key];});
		// 		items3.sort(sortFunction);
		// 		for (let k3 in items3) {
		// 			let dom3 = new HtmlDom(commonAddBubbleCatItemTemplate, {id:items3[k3].id, name:items3[k3].name, class:'ssubcat'}, this);
		// 			if (dom3) catDoms.push(dom3);
		// 			dom2.appendChild(dom3);
		// 		}
		// 	}
		// }
		// this.catItems = catDoms;
		// this.catsDom = dom0;
	};
	this.initBubble = function () {
	// 	if (this.containers.bubbleItems) this.containers.bubbleItems.innerHTML = '';
	// //	if (this.containers.bubbleHeader) this.containers.bubbleHeader.innerHTML = '';
	// 	if (this.catsDom && this.containers.bubbleCats) {
	// 		this.containers.bubbleCats.innerHTML='';
	// 		this.containers.bubbleCats.appendChild(this.catsDom);
	// 	}
	};

	this.search = function() {
		// let str = o.value.toString().trim().toLocaleLowerCase();
		// let self = this;
		// if (!this.emptyBubbleData) {
		// 	for (let k in self.bubbleItemClasses) {
		// 		if (Object.prototype.hasOwnProperty.call(self.bubbleItemClasses, k) && self.bubbleItemClasses[k]) {
		// 			let v = self.bubbleItemClasses[k];
		// 			if (v.name) {
		// 				let name = v.name.toString().toLowerCase();
		// 				//console.log(v);
		// 				if (name.indexOf(str) < 0) {
		// 					v.domGroupAdd.style.display = 'none';
		// 				} else {
		// 					v.domGroupAdd.style.display = 'table-row';
		// 				}
		// 			}
		// 		}
		// 	}
		// }
	};




	// this.bubbleLoaded = function (items) {
	this.bubbleLoaded = function () {
		// if (this.containers.bubbleItems) {
		// 	// this.containers.bubbleItems.innerHTML = '';
		// 	// this.containers.bubbleItems.appendChild(this.addButton);
		// 	//let table_goods = document.createElement('table');
		// 	//table_goods.style.width = '100%';
		// 	//this.containers.bubbleItems.appendChild(table_goods);
		// 	this.bubbleItemClasses = [];
		// 	// let i = 0;
		// 	let items2 = this.srt(items);
		// 	//table_goods.innerHTML = groupHeaderTemplate;
		// 	let self = this;
		// 	for (let k in items2) {
		// 		if (Object.prototype.hasOwnProperty.call(items2, k)) {
		// 			let v = items2[k];
		// 			v.count = v.package;
		// 			v.cnt_per_all = this.amountAct;
		// 			//self.bubbleItemClasses[k] = new AI_helperItemClass(v, this, function () {self.check_complect();},'groupAdd');
		//
		// 			self.bubbleItemClasses[k] = new AI_helperItemClass(v, self, function (param) {self.event(param);}, 'groupAdd');
		//
		//
		// 			self.bubbleItemClasses[k].selected = false;
		// 			if (self.bubbleItemClasses[k].controls.addButtonGroupAdd) {
		// 				self.bubbleItemClasses[k].selected = false;
		// 				self.bubbleItemClasses[k].controls.addButtonGroupAdd.setAttribute('value', 'Выбрать');
		//
		// 				self.bubbleItemClasses[k].controls.addButtonGroupAdd.onclick = function () {
		// 					if (self.bubbleItemClasses[k].selected) {
		// 						self.bubbleItemClasses[k].domGroupAdd.style.background = "#fff";
		// 						self.bubbleItemClasses[k].controls.addButtonGroupAdd.setAttribute('value', 'Выбрать');
		// 						self.bubbleItemClasses[k].selected = false;
		// 					} else {
		// 						self.bubbleItemClasses[k].domGroupAdd.style.background = "#ffe787";
		// 						self.bubbleItemClasses[k].controls.addButtonGroupAdd.setAttribute('value', 'Отменить');
		// 						self.bubbleItemClasses[k].selected = true;
		// 					}
		// 					if (self.bubbleItemClasses)
		// 						self.collect_selected_items(self.bubbleItemClasses);
		// 				}
		// 			}
		// 			if (window.in_array(self.bubbleItemClasses[k].id, self.ids)) {
		// 				delete (self.bubbleItemClasses[k]);
		// 				self.bubbleItemClasses.splice(k, 1);
		// 			} else {
		// 				//self.bubbleItemClasses[k].appendGroupAdd(table_goods);
		// 				self.bubbleItemClasses[k].appendGroupAdd(self.containers.bubbleItems);
		// 				// i++;
		// 			}
		// 		}
		// 	}
		// 	// if (i <= 0)
		// 		// this.containers.bubbleItems.innerHTML = '<br /><br />В ЭТОЙ ГРУППЕ ДРУГИХ ТОВАРОВ НЕТ!<br /><br /><br /><br />';
		// }
	};
	this.showBubble = function() {
		// if (this.bubble) {
		// 	this.initBubble();
		// 	this.bubble.style.display = 'block';
		// }
	};
	this.hideBubble = function() {
		// if (this.bubble) this.bubble.style.display = 'none';
	};
	this.addButtonClick = function() {
		// for (let k in this.selected_items) {
		// 	if (Object.prototype.hasOwnProperty.call(this.selected_items, k)) {
		// 		let item = this.selected_items[k];
		// 		item.addItem();
		// 		item.domGroupAdd.style.display = "none";//destroy();
		// 		//	console.log(item);
		// 	}
		// }
		// this.selected_items = [];
		// this.addButton.style.display = "none";
		// //self.bubbleDestroy();
		// this.check_complect();
	};
	this.bubbleDestroy = function () {
		// this.selected_items = [];
		// this.bubble.parentNode.removeChild(this.bubble);
		// delete (this.bubble);
	};
	this.init(o);
}; //class
export default AI_helperCommonClass
